export type UpdateOrganizationTaxId = {
	response: 'success';
};

const model: types.models.InputModel = {
	response: 'response.updateOrganizationTaxIdResponse.response',
};

export default model;
